import { FileText, LucideIcon } from "lucide-react";
import { Button } from "@/components/ui/button";
import Link from "next/link";

interface EmptyStateProps {
    title?: string;
    description?: string;
    actionLabel?: string;
    actionLink?: string;
    icon?: LucideIcon;
    action?: () => void;
}

export function EmptyState({
    title = "No data found",
    description = "We couldn't find any data at the moment. Please check back later.",
    actionLabel,
    actionLink,
    icon: Icon = FileText,
    action,
}: EmptyStateProps) {
    return (
        <div className="flex flex-col items-center justify-center py-16 px-4 text-center rounded-xl border border-dashed border-border/60 bg-muted/20">
            <div className="bg-primary/5 p-5 rounded-full mb-6 ring-8 ring-primary/5">
                <Icon className="w-10 h-10 text-primary/60" strokeWidth={1.5} />
            </div>
            <h3 className="text-xl font-semibold mb-2 text-foreground tracking-tight">{title}</h3>
            <p className="text-muted-foreground max-w-sm mb-8 text-sm leading-relaxed">
                {description}
            </p>
            {actionLink && actionLabel && !action && (
                <Button asChild variant="default" size="sm" className="rounded-full px-6">
                    <Link href={actionLink}>{actionLabel}</Link>
                </Button>
            )}
            {action && actionLabel && !actionLink && (
                <Button onClick={action} variant="default" size="sm" className="rounded-full px-6">
                    {actionLabel}
                </Button>
            )}
        </div>
    );
}
